import {
  each,
  equals2,
  filterL,
  go,
  isNil,
  map,
  mapL,
  rejectL,
  takeAll,
} from "fxjs/es";
import { ArtBoardNS } from "../../../../../../ArtBoard/ArtBoardNS.js";
import { BackgroundNS } from "../../../../../../Background/BackgroundNS.js";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { RubberBandNS } from "../../../../../../RubberBand/RubberBandNS.js";
import { SelectionNS } from "../../../../../../Selection/SelectionNS.js";
import { SelectorNS } from "../../../../../../Selector/SelectorNS.js";
import { TransformNS } from "../../../../../../Transform/TransformNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
export const initEditor = (self) => {
  const canvas_el = self._getCanvasElThrowable();
  const dummy_g_el = self._getDummyGElThrowable();
  const layers_el = self._getLayersElThrowable();
  const rubber_band_layer_el = self._getRubberBandLayerElThrowable();
  const art_board_rect_el = self._getArtBoardRectElThrowable();
  const art_board_filter_drop_shadow_el =
    self._getArtBoardFilterDropShadowElThrowable();
  const rubber_band_el = self._getRubberBandElThrowable();
  const selector_path_el = self._getSelectorPathElThrowable();
  const selector_nw_circle_el = self._getSelectorNWCircleElThrowable();
  const selector_ne_circle_el = self._getSelectorNECircleElThrowable();
  const selector_se_circle_el = self._getSelectorSECircleElThrowable();
  const selector_sw_circle_el = self._getSelectorSWCircleElThrowable();
  const selector_r_circle_el = self._getSelectorRCircleElThrowable();
  const background_base_el = self._getBackgroundBaseElThrowable();
  const background_color_el = self._getBackgroundColorElThrowable();
  const background_image_el = self._getBackgroundImageElThrowable();
  const view_port = new ViewPortNS.ModelNS.ViewPort({
    width: 0,
    height: 0,
  });
  self._view_port = view_port;
  const view_port_controller = new ViewPortNS.ControllerNS.ViewPortController({
    view_port,
  });
  new ViewPortNS.ViewNS.ViewPortElView({
    view_port_el: canvas_el,
    view_port_controller,
  });
  new ViewPortNS.ViewNS.ViewPortElView({
    view_port_el: layers_el,
    view_port_controller,
  });
  const view_box = new ViewBoxNS.ModelNS.ViewBox({
    svg_el: self._svg_el,
    min_s: 0.4,
    max_s: 2,
  });
  self._view_box = view_box;
  const view_box_controller = new ViewBoxNS.ControllerNS.ViewBoxController({
    view_box,
  });
  new ViewBoxNS.ViewNS.ViewBoxElView({
    view_box_el: layers_el,
    view_box_controller,
  });
  const art_board = new ArtBoardNS.ModelNS.ArtBoard({
    width: 0,
    height: 0,
    svg_el: self._svg_el,
    getCTM: () => {
      const ctm = art_board_rect_el.getCTM();
      if (ctm == null) {
        throw new Error(`아트보드 엘리먼트의 CTM 을 구할 수 없습니다.`);
      }
      return ctm;
    },
  });
  self._art_board = art_board;
  const art_board_controller = new ArtBoardNS.ControllerNS.ArtBoardController({
    art_board,
  });
  new ArtBoardNS.ViewNS.ArtBoardView({
    art_board_controller,
    art_board_rect_el,
    art_board_filter_drop_shadow_el,
  });
  const background = new BackgroundNS.ModelNS.Background({
    value: new BackgroundNS.ModelNS.BackgroundColorValue({
      fill: "none",
      opacity: 1,
    }),
    art_board,
  });
  self._background = background;
  const background_controller =
    new BackgroundNS.ControllerNS.BackgroundController({
      background,
    });
  new BackgroundNS.ViewNS.BackgroundView({
    background_base_el,
    background_color_el,
    background_image_el,
    background_controller,
  });
  const selector_controller =
    new SelectorNS.ControllerNS.FreeStickerEditorSelectorController({
      svg_el: self._svg_el,
      transform_manipulator: self._transform_manipulator,
      getCTM: () => {
        const ctm = dummy_g_el.getCTM();
        if (ctm == null) {
          throw new Error(`selector 엘리먼트의 CTM 을 구할 수 없습니다.`);
        }
        return ctm;
      },
    });
  self._selector_controller = selector_controller;
  const selector_path_view = new SelectorNS.ViewNS.SelectorPathView({
    selector_path_el,
  });
  selector_controller.subscribe((vo) =>
    selector_path_view.observeSelectorController(vo)
  );
  const selector_circle_view = new SelectorNS.ViewNS.SelectorSimpleCircleView({
    r_circle_d: 24,
    transparent_d: 120,
    selector_ne_circle_el,
    selector_se_circle_el,
    selector_sw_circle_el,
    selector_nw_circle_el,
    selector_r_circle_el,
  });
  selector_controller.subscribe((vo) =>
    selector_circle_view.observeSelectorController(vo)
  );
  const rubber_band = new RubberBandNS.ModelNS.RubberBand();
  rubber_band.subscribe(({ status, point1, point2 }) => {
    if (!equals2(status)("END")) {
      return;
    }
    const rubber_band_layer_el_ctm = rubber_band_layer_el.getCTM();
    if (rubber_band_layer_el_ctm == null) {
      return;
    }
    const viewport_point1 = CommonNS.UtilNS.createSVGPoint(self._svg_el)([
      point1.x,
      point1.y,
    ]).matrixTransform(rubber_band_layer_el_ctm);
    const viewport_point2 = CommonNS.UtilNS.createSVGPoint(self._svg_el)([
      point2.x,
      point2.y,
    ]).matrixTransform(rubber_band_layer_el_ctm);
    const points = [
      {
        x: viewport_point1.x,
        y: viewport_point1.y,
      },
      {
        x: viewport_point2.x,
        y: viewport_point1.y,
      },
      {
        x: viewport_point2.x,
        y: viewport_point2.y,
      },
      {
        x: viewport_point1.x,
        y: viewport_point2.y,
      },
    ];
    const old_selected_el_ids = self._selected_el_ids;
    const new_selected_el_ids = go(
      self._els.values(),
      filterL(({ cutting_line_clip_path_el }) => {
        const ctm = cutting_line_clip_path_el.getCTM();
        if (ctm == null) {
          return false;
        }
        const bbox = cutting_line_clip_path_el.getBBox();
        const wrapper_el_points = go(
          [
            [bbox.x, bbox.y],
            [bbox.x + bbox.width, bbox.y],
            [bbox.x + bbox.width, bbox.y + bbox.height],
            [bbox.x, bbox.y + bbox.height],
          ],
          mapL(CommonNS.UtilNS.createSVGPoint(self._svg_el)),
          mapL((point) => point.matrixTransform(ctm)),
          map(({ x, y }) => ({
            x,
            y,
          }))
        );
        return (
          SelectionNS.ModelNS.checkAreaIntersection({
            points1: points,
            points2: wrapper_el_points,
          }) ||
          SelectionNS.ModelNS.checkAreaEnclosure({
            points1: points,
            points2: wrapper_el_points,
          })
        );
      }),
      mapL(({ id }) => id),
      (ids) => new Set(ids)
    );
    const els = go(
      self._els.entries(),
      filterL(([id]) => new_selected_el_ids.has(id)),
      (entries) => new Map(entries)
    );
    const selected_els = go(
      new_selected_el_ids,
      rejectL((id) => old_selected_el_ids.has(id)),
      mapL((id) => self._els.get(id)),
      rejectL(isNil),
      takeAll
    );
    const unselected_els = go(
      old_selected_el_ids,
      rejectL((id) => new_selected_el_ids.has(id)),
      mapL((id) => self._els.get(id)),
      rejectL(isNil),
      takeAll
    );
    const new_selected_els = go(
      new_selected_el_ids,
      mapL((id) => self._els.get(id)),
      rejectL(isNil),
      takeAll
    );
    self._selected_el_ids = new_selected_el_ids;
    selector_controller.syncWith(els);
    CommonNS.UtilNS.tryNoop(() =>
      each((el) =>
        CommonNS.UtilNS.tryNoop(() =>
          el.wrapper_el.dispatchEvent(
            new CustomEvent("@mp/sticker-editor/select", {
              bubbles: true,
              cancelable: true,
              composed: false,
              detail: {
                el,
                selected_els: new_selected_els,
              },
            })
          )
        )
      )(selected_els)
    );
    CommonNS.UtilNS.tryNoop(() =>
      each((el) =>
        CommonNS.UtilNS.tryNoop(() =>
          el.wrapper_el.dispatchEvent(
            new CustomEvent("@mp/sticker-editor/unselect", {
              bubbles: true,
              cancelable: true,
              composed: false,
              detail: {
                el,
                selected_els: new_selected_els,
              },
            })
          )
        )
      )(unselected_els)
    );
  });
  self._rubber_band = rubber_band;
  const rubber_band_controller =
    new RubberBandNS.ControllerNS.RubberBandController({
      rubber_band,
    });
  new RubberBandNS.ViewNS.RubberBandView({
    rubber_band_el,
    rubber_band_controller,
  });
  const selector_controller_observer1 = ({ status, matrix }) => {
    if (equals2(status)("START") || equals2(status)("END")) {
      const els = go(
        self._els.entries(),
        filterL(([id]) => self._selected_el_ids.has(id)),
        (entries) => new Map(entries)
      );
      selector_controller.syncWith(els);
      return;
    }
    selector_controller.transform(matrix);
  };
  const translate_transforming = new TransformNS.ModelNS.TranslateTransforming({
    svg_el: self._svg_el,
    transform_manipulator: self._transform_manipulator,
  });
  self._translate_transforming = translate_transforming;
  translate_transforming.subscribe(selector_controller_observer1);
  const rotate_transforming = new TransformNS.ModelNS.RotateTransforming({
    svg_el: self._svg_el,
    transform_manipulator: self._transform_manipulator,
  });
  self._rotate_transforming = rotate_transforming;
  rotate_transforming.subscribe(({ status, matrix }) => {
    selector_controller.setMode(equals2(status)("END") ? "DEFAULT" : "ROTATE");
    if (equals2(status)("START") || equals2(status)("END")) {
      const els = go(
        self._els.entries(),
        filterL(([id]) => self._selected_el_ids.has(id)),
        (entries) => new Map(entries)
      );
      selector_controller.syncWith(els);
      return;
    }
    selector_controller.transform(matrix);
  });
  const scale_transform = new TransformNS.ModelNS.ScaleTransform({
    svg_el: self._svg_el,
    transform_manipulator: self._transform_manipulator,
  });
  const scale_transforming1 = new TransformNS.ModelNS.ScaleTransforming1({
    svg_el: self._svg_el,
    transform_manipulator: self._transform_manipulator,
    scale_transform,
  });
  self._scale_transforming1 = scale_transforming1;
  scale_transforming1.subscribe(selector_controller_observer1);
  const scale_transforming2 = new TransformNS.ModelNS.ScaleTransforming2({
    svg_el: self._svg_el,
    transform_manipulator: self._transform_manipulator,
    scale_transform,
  });
  self._scale_transforming2 = scale_transforming2;
  scale_transforming2.subscribe(selector_controller_observer1);
  const translate_transform = new TransformNS.ModelNS.TranslateTransform({
    svg_el: self._svg_el,
    transform_manipulator: self._transform_manipulator,
  });
  self._translate_transform = translate_transform;
  translate_transform.subscribe(() => {
    const els = go(
      self._els.entries(),
      filterL(([id]) => self._selected_el_ids.has(id)),
      (entries) => new Map(entries)
    );
    selector_controller.syncWith(els);
  });
  const touchStartOnCanvasElHandler = (event) =>
    self._handleTouchStartOnCanvasEl(event);
  const touchStartOnSelectorPathElHandler = (event) =>
    self._handleTouchStartOnSelectorPathEl(event);
  const touchStartOnSelectorRotateCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorRotateCircleEl(event);
  const touchStartOnSelectorScaleNECircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_sw_circle_el,
      x_axis_circle_el: selector_se_circle_el,
      y_axis_circle_el: selector_nw_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
    });
  const touchStartOnSelectorScaleSECircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_nw_circle_el,
      x_axis_circle_el: selector_ne_circle_el,
      y_axis_circle_el: selector_sw_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
    });
  const touchStartOnSelectorScaleSWCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_ne_circle_el,
      x_axis_circle_el: selector_nw_circle_el,
      y_axis_circle_el: selector_se_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
    });
  const touchStartOnSelectorScaleNWCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_se_circle_el,
      x_axis_circle_el: selector_sw_circle_el,
      y_axis_circle_el: selector_ne_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
    });
  const touchMoveHandler = (event) => self._handleTouchMove(event);
  const touchEndOrCancelHandler = (event) =>
    self._handleTouchEndOrCancel(event);
  self._touchStartOnCanvasElHandler = touchStartOnCanvasElHandler;
  self._touchStartOnSelectorPathElHandler = touchStartOnSelectorPathElHandler;
  self._touchStartOnSelectorRotateCircleElHandler =
    touchStartOnSelectorRotateCircleElHandler;
  self._touchStartOnSelectorScaleNECircleElHandler =
    touchStartOnSelectorScaleNECircleElHandler;
  self._touchStartOnSelectorScaleSECircleElHandler =
    touchStartOnSelectorScaleSECircleElHandler;
  self._touchStartOnSelectorScaleSWCircleElHandler =
    touchStartOnSelectorScaleSWCircleElHandler;
  self._touchStartOnSelectorScaleNWCircleElHandler =
    touchStartOnSelectorScaleNWCircleElHandler;
  self._touchMoveHandler = touchMoveHandler;
  self._touchEndOrCancelHandler = touchEndOrCancelHandler;
  canvas_el.addEventListener("touchstart", touchStartOnCanvasElHandler, {
    passive: false,
  });
  selector_path_el.addEventListener(
    "touchstart",
    touchStartOnSelectorPathElHandler,
    {
      passive: false,
    }
  );
  selector_r_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorRotateCircleElHandler,
    {
      passive: false,
    }
  );
  selector_ne_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleNECircleElHandler,
    {
      passive: false,
    }
  );
  selector_se_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleSECircleElHandler,
    {
      passive: false,
    }
  );
  selector_sw_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleSWCircleElHandler,
    {
      passive: false,
    }
  );
  selector_nw_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleNWCircleElHandler,
    {
      passive: false,
    }
  );
  self._window.addEventListener("touchmove", touchMoveHandler, {
    passive: false,
  });
  self._window.addEventListener("touchend", touchEndOrCancelHandler, {
    passive: false,
  });
  self._window.addEventListener("touchcancel", touchEndOrCancelHandler, {
    passive: false,
  });
};
